import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Footer.css";

const Footer = (props) => {
  return (
    <footer className="py-4 my-5 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col className="col-sm-2 text-center">
            <a href="https://www.facebook.com/officialmcmta/" target="_blank" rel="noreferrer" className="btn-social btn-facebook"><i className="fa fa-facebook"></i></a>
            <a href="mailto:webmaster@msmta.org" target="_blank" rel="noreferrer" className="btn-social btn-email"><i className="fa fa-envelope"></i></a>
          </Col>
          {/* <Col className="col-sm-2 text-center"><strong>{genConf.presidentName}</strong></Col> */}
        </Row>
        <Row className="justify-content-center">
          <Col className="text-center">
            {/* <strong>President</strong> */}
            <br></br>
          </Col>
        </Row>
        <p className="text-center ">
          Copyright &copy;: {new Date().getFullYear()}{" "}
          Montgomery County Music Teacher's Association <a href="https://mcmta.msmta.org">[MCMTA]</a>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
